<div class="w3-container w3-margin">

  <!-- <h2>วันที่ที่เลือก:</h2>
  <p *ngIf="receivedDate; else noDate">
    {{ receivedDate }}
  </p>

  <p *ngIf="receiveSupcode; else noDate">
    {{ receiveSupcode }}
  </p>

  <ng-template #noDate>
    <p>ยังไม่มีการเลือกวันที่</p>
  </ng-template> -->

  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#7bff76" type="timer" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
  </ngx-spinner>

  <section class="invoice" #supervisReport>
    <div class="row w3-blue" style="padding: 5px;"></div>
    <div class="row w3-pale-blue" style="margin-top: 5px;">
      <div class="col-7 w3-right">
        <span class="w3-xlarge prompt-regular">
          รายงานฤดูหีบอ้อย ปีการผลิต 2567/2568
        </span>
      </div>
      <div class="col-5" style="text-align: right">
        <h5 class="page-header w3-center ggPrompt">
          <i class="fas fa-user-tie"></i> {{ brddata.supcode }} | {{ brddata.supname }}
          <!-- <small class="float-right w3-small">Date: 2/10/2014</small> -->
        </h5>
      </div>
      <div class="col-12 w3-left">
        <span class=" prompt-regular">
          ประจำ{{ dateLabel }}
        </span>
      </div>
    </div>

    <div *ngIf="brddata" class="row w3-pale-blue">
      <div class="col-12 table-responsive">
        <table class="table table-striped w3-card-4 prompt-regular">
          <thead>
            <tr class="prompt-semibold">
              <th>#</th>
              <th class="w3-right-align">เป้าหมาย</th>
              <th class="w3-right-align">วันนี้</th>
              <th class="w3-right-align">สะสม</th>
              <th class="w3-center">%</th>
              <th class="w3-right-align">คงเหลือ</th>
            </tr>
          </thead>
          <tbody>
            <tr class="prompt-bold">
              <th colspan="6"><i class="fas fa-chart-line"></i> 1.เชิงปริมาณ</th>
            </tr>
            <tr>
              <td style="padding-left: 15px;">พื้นที่ปลูก(ไร่)</td>
              <td class="w3-right-align">{{ brddata.canearea_target | number }}</td>
              <td class="w3-right-align"></td>
              <td class="w3-right-align">{{ brddata.canearea | number }}</td>
              <td class="w3-center">{{ brddata.pc_canearea | number }}%</td>
              <td class="w3-right-align">{{ brddata.sugarcane_area_difference | number }}</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">อ้อยเข้าหีบ(ตัน)</td>
              <td class="w3-right-align">{{ brddata.sugarcane_estimate | number }}</td>
              <td class="w3-right-align">{{ brddata.sugarcane_today | number }}</td>
              <td class="w3-right-align">{{ brddata.sugarcane | number }}</td>
              <td class="w3-center">{{ brddata.pc_sugarcane | number }}%</td>
              <td class="w3-right-align">{{ brddata.sugarcane_left | number }}</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">แปลงตัดเสร็จ(ไร่)</td>
              <td class="w3-right-align">{{ brddata.canearea | number }}</td>
              <td class="w3-right-align">{{ brddata.plotcuted_area_today | number }}</td>
              <td class="w3-right-align">{{ brddata.plotcuted_area | number }}</td>
              <td class="w3-center">{{ brddata.pc_plotcuted_area | number }}%</td>
              <td class="w3-right-align">{{ brddata.plotcuted_area_difference | number }}</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">แปลงตัดเสร็จ(ตัน <span class="w3-small">*ตัดพันธุ์
                  {{ brddata.plotcuted_cutseed | number }}</span>)</td>
              <td class="w3-right-align">{{ brddata.plotcuted_target | number }}</td>
              <td class="w3-right-align">{{ brddata.plotcuted_canein_today | number }}</td>
              <td class="w3-right-align">{{ brddata.plotcuted_canein + brddata.plotcuted_cutseed | number }}</td>
              <td class="w3-center">{{ brddata.pc_plotcuted_canein | number }}%</td>
              <td class="w3-right-align">{{ brddata.plotcuted_canein_difference | number }}</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">ปริมาณอ้อยไฟ(<5%)</td> <td class="w3-right-align">
                  <{{ brddata.sugarcaneFire_target | number }}</td> <td class="w3-right-align">
                    {{ brddata.sugarcaneFire_today | number }}</td>
              <td class="w3-right-align">{{ brddata.sugarcaneFire | number }}</td>
              <td class="w3-center">{{ brddata.pc_sugarcaneFire | number }}%</td>
              <td class="w3-right-align">{{ brddata.sugarcaneFire_difference | number }}</td>
            </tr>
            <tr class="prompt-bold">
              <th colspan="6"><i class="fas fa-award"></i> 2.เชิงคุณภาพ</th>
            </tr>
            <tr>
              <td style="padding-left: 15px;">CCS.</td>
              <td class="w3-right-align">{{ brddata.ccs_target | number }}</td>
              <td class="w3-right-align">{{ brddata.ccs_today | number }}</td>
              <td class="w3-right-align">{{ brddata.ccs | number }}</td>
              <td class="w3-center">{{ brddata.pc_ccs | number }}%</td>
              <td class="w3-right-align">{{ brddata.ccs_difference | number }}</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">น้ำตาล กก./ไร่เทียบ CCS. (BRR วันนี้
                {{ brddata.sugarperccs_today_brr | number }} สะสม {{ brddata.sugarperccs_brr | number }})</td>
              <td class="w3-right-align"></td>
              <td class="w3-right-align">{{ brddata.sugarperrai_ccs_today | number }}</td>
              <td class="w3-right-align">{{ brddata.sugarperrai_ccs | number }}</td>
              <td class="w3-center">%</td>
              <td class="w3-right-align"></td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">น้ำตาล กก./ไร่เทียบน้ำตาลที่ผลิตได้(BRR วันนี้ {{ brddata.sugarperton_today_brr | number }} สะสม {{ brddata.sugarperton_brr | number }})</td>
              <td class="w3-right-align"></td>
              <td class="w3-right-align">{{ brddata.sugarperraiNikul_ccs_today | number }}</td>
              <td class="w3-right-align">{{ brddata.sugarperraiNikul_ccs | number }}</td>
              <td class="w3-center">%</td>
              <td class="w3-right-align"></td>
            </tr>
            <!-- <tr>
                <td style="padding-left: 15px;">น้ำตาล/ไร่ เทียบน้ำตาลผลิตได้จริง (%น้ำตาล/อ้อย วันนี้ {{ brddata.sugarperton_today_brr | number }})</td>
                <td class="w3-right-align"></td>
                <td class="w3-right-align">{{ brddata.sugarperrai_yield_today | number }}</td>
                <td class="w3-right-align">{{ brddata.sugarperrai_yield | number }}</td>
                <td class="w3-center">%</td>
                <td class="w3-right-align"></td>
              </tr> -->
            <tr>
              <td style="padding-left: 15px;">ผลผลิต (ตัน/ไร่)</td>
              <td class="w3-right-align">{{ brddata.yield_target | number }}</td>
              <td class="w3-right-align">{{ brddata.yield_today | number }}</td>
              <td class="w3-right-align">{{ brddata.yield | number }}</td>
              <td class="w3-center">{{ brddata.pc_yield | number }}%</td>
              <td class="w3-right-align">{{ brddata.yield_difference | number }}</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">ผลผลิต อ้อยปลายฝน (ตัน/ไร่)</td>
              <td class="w3-right-align">{{ brddata.yield_er_target | number }}</td>
              <td class="w3-right-align">{{ brddata.yield_today_er | number }}</td>
              <td class="w3-right-align">{{ brddata.yield_er | number }}</td>
              <td class="w3-center">{{ brddata.pc_yield_er | number }}%</td>
              <td class="w3-right-align">{{ brddata.yield_er_difference | number }}</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">ผลผลิต อ้อยตอ (ตัน/ไร่)</td>
              <td class="w3-right-align">{{ brddata.yield_st_target | number }}</td>
              <td class="w3-right-align">{{ brddata.yield_today_st | number }}</td>
              <td class="w3-right-align">{{ brddata.yield_st | number }}</td>
              <td class="w3-center">{{ brddata.pc_yield_st | number }}%</td>
              <td class="w3-right-align">{{ brddata.yield_st_difference | number }}</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">ผลผลิต อ้อยต้นฝน (ตัน/ไร่)</td>
              <td class="w3-right-align">{{ brddata.yield_sr_target | number }}</td>
              <td class="w3-right-align">{{ brddata.yield_today_sr | number }}</td>
              <td class="w3-right-align">{{ brddata.yield_sr | number }}</td>
              <td class="w3-center">{{ brddata.pc_yield_sr | number }}%</td>
              <td class="w3-right-align">{{ brddata.yield_sr_difference | number }}</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">ผลผลิต BRR Model (ตัน/ไร่) (พท.{{ brddata.landvalue_brrModel | number }}
                ไร่)</td>
              <td class="w3-right-align"></td>
              <td class="w3-right-align"></td>
              <td class="w3-right-align">{{ brddata.yield_brrModel | number }}</td>
              <td class="w3-center">%</td>
              <td class="w3-right-align"></td>
            </tr>
            <tr class="prompt-bold">
              <th colspan="6"><i class="fas fa-chart-line"></i> 3.การบริหารจัดการ</th>
            </tr>
            <tr>
              <td style="padding-left: 15px;">% Trash (วันนี้ BRR {{ brddata.trash_today_brr | number }})</td>
              <td class="w3-right-align">1</td>
              <td class="w3-right-align">{{ brddata.trash_today_brr | number }}</td>
              <td class="w3-right-align">{{ brddata.trash_brr | number }}</td>
              <td class="w3-center">{{ brddata.pc_trash | number }}%</td>
              <td class="w3-right-align"></td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">คิวอ้อย (ชั่วโมง/รอบ รอบ {{ brddata.ref_doc1 | number }})</td>
              <td class="w3-right-align"></td>
              <td class="w3-right-align"></td>
              <td class="w3-right-align">{{ brddata.period_hour | number }}</td>
              <td class="w3-center"></td>
              <td class="w3-right-align"></td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">อ้อยค้างไร่(เกิน 24ชม.)</td>
              <td class="w3-right-align">{{ brddata.cntQ13 | number }}</td>
              <td class="w3-right-align">
                {{ brddata.period_cutToFac24_today | number }}/{{ brddata.cntQ13_today | number }}</td>
              <td class="w3-right-align">{{ brddata.period_cutToFac24 | number }}</td>
              <td class="w3-center">{{ brddata.pc_period_cutToFac24 | number }}%</td>
              <td class="w3-right-align"></td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">การสูญเสียจากการตัด (กก./ไร่)</td>
              <td class="w3-right-align">
                <300</td> <td class="w3-right-align">{{ brddata.lossCutting_today | number }}
              </td>
              <td class="w3-right-align">{{ brddata.lossCutting | number }}</td>
              <td class="w3-center">{{ brddata.pc_lossCutting | number }}%</td>
              <td class="w3-right-align"></td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">คาดหนี้ค้าง (ราย)</td>
              <td class="w3-right-align">{{ brddata.outstandingDebt_target | number }}</td>
              <td class="w3-right-align">{{ brddata.outstandingDebt_today | number }}</td>
              <td class="w3-right-align">{{ brddata.outstandingDebt_amount | number }}</td>
              <td class="w3-center">{{ brddata.pc_outstandingDebt | number }}%</td>
              <td class="w3-right-align"></td>
            </tr>
            <tr>
              <td style="padding-left: 15px;"></td>
              <td class="w3-right-align"></td>
              <td class="w3-right-align"></td>
              <td class="w3-right-align"></td>
              <td class="w3-right-align"></td>
              <td class="w3-right"><i class="fab fa-connectdevelop"></i> itBRD</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>


  </section>
</div>
